
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/Document/Document.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./Document.html');
        
        var script = require('./Document.ts').default;
        module.exports = require('./Document.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    